"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.xStreamId = exports.isAndroid = exports.isIos = exports.isInApp = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
// 是否在H5PlusApp环境中
function isInApp() {
    return Boolean(window.plus && window.plus.runtime);
}
exports.isInApp = isInApp;
// 是否是 ios app web
function isIos() {
    return window.plus.os.name === 'iOS';
}
exports.isIos = isIos;
// 是否是 android app web
function isAndroid() {
    return window.plus.os.name === 'Android';
}
exports.isAndroid = isAndroid;
/**
 * 获取鉴权token
 */
function xStreamId() {
    try {
        // 获取本地存储的x-stream-id
        var data = window.plus.storage.getItem('x-stream-id-jssdk');
        if (!data)
            return null;
        data = JSON.parse(data);
        // 判断是否有值
        if (!(data === null || data === void 0 ? void 0 : data.value))
            return null;
        // 判断是否过期
        if (data.expireTimeStamp && (0, dayjs_1.default)().valueOf() > Number(data.expireTimeStamp)) {
            // 过期则清除
            window.plus.storage.removeItem('x-stream-id-jssdk');
            return null;
        }
        // 判断是否是字符串化的数据
        return data.stringified === '1' ? JSON.parse(data.value) : data.value;
    }
    catch (error) {
        return null;
    }
}
exports.xStreamId = xStreamId;
//# sourceMappingURL=system.js.map